import axios from 'axios'

const state = {
  status: '',
  token: localStorage.getItem('token') || '',
  user: {},
  workers: [],
  employeeProfiles: [],
  workerTypes: [],
  worksites: []
}

const getters = {
  getUser: state => state.user,
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  getWorkSites: state => state.worksites,
  worksessionStarted: state => state.user.workSession !== null,
  activeWS: state => state.user.workSession,
  workers: state => state.workers,
  managerTime: state => state.user.workSession.hoursSpent
}

const mutations = {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, token) {
    state.status = 'success'
    state.token = token
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.token = ''
  },
  set_user (state, user) {
    state.user = user
  },
  set_workers (state, workers) {
    state.workers = workers
  },
  set_worksites (state, worksites) {
    state.worksites = worksites
  },
  set_employee_profiles (state, profiles) {
    state.employeeProfiles = profiles
  },
  set_worker_types (state, types) {
    state.workerTypes = types
  },
  delete_worksession (state) {
    state.user.workSession = null
  },
  end_worksession (state) {
    state.user.workSession = null
  },
  update_manager_hours (state, newVal) {
    state.user.workSession.hoursSpent = newVal
  },
  update_worklog_hours (state, workLog) {
    const index = state.user.workSession.workLogs.findIndex(item => item.workLogId === workLog.id)
    state.user.workSession.workLogs[index].hoursWorked = workLog.newVal
  }
}

const actions = {
  login ({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post('login', user)
        .then(resp => {
          const token = `Bearer ${resp.data.access_token}`
          // const user = resp.data.user
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = token
          commit('auth_success', token)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      // axios.post('https://salary.harea.co.uk/api/logout')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },
  async fetchUserData ({ commit }) {
    const response = await axios.get('user')
    commit('set_user', response.data)
  },
  fetchWorkSites({ commit }) {
    axios.get('worksites')
      .then(resp => {
        commit('set_worksites', resp.data)
      })
  },
  startWorksession ({ commit }, ws) {
    return new Promise((resolve, reject) => {
      axios.post('worksessions', ws)
        .then(response => {
          console.log(response)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteWorksession ({commit}, id) {
    axios.delete(`worksessions/${id}`)
      .then(response => {
        console.log(response)
        commit('delete_worksession')
      })
      .catch(err => {
        console.log(err)
      })
  },
  fetchWorkers({commit}) {
    return new Promise((resolve, reject) => {
      axios.get('workers')
        .then(response => {
          commit('set_workers', response.data)
          resolve();
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  saveWorkLogs ({ commit }, workLogs) {
    return new Promise((resolve, reject) => {
      axios.post('worklog', workLogs)
        .then(resolve)
        .catch(reject)
    })
  },
  endWorksession ({ commit }, id) {
    axios.get(`worksessions/end/${id}`)
      .then(resp => {
        commit('end_worksession')
      })
      .catch(err => {
        console.log(err)
      })
  },
  updateManagerHours ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.put(`worksessions/${data.worksessionId}`, data)
        .then(resp => {
          commit('update_manager_hours', data.spentHours)
          resolve()
        })
        .catch(reject)
    })
  },
  updateWorkLogHours ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.put(`worklog/${data.workLogId}`, data)
        .then(resp => {
          commit('update_worklog_hours', {id: data.workLogId, newVal: data.spentHours})
          resolve()
        })
        .catch(reject)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
